import React from "react";
import styles from "./styles.css";
import withAULayout from "../../../components/au.desktop/layout";
import Helmet from "react-helmet";
import ErrorHandler from "../../../components/shared/with-error-handler";
import loadable from "@loadable/component";
const ContactUsInfo = loadable(() => import("../../../components/shared/contact-us-info-new"), {
    fallback: <PageLoader />
});
import { trackDesktopCustomEventsAU } from "../../../tracking";
import PageLoader from "../../../components/shared/page-loader";
const CONTACT_US_TITLE = "Contact us | Cars24 Australia";
const CONTACT_US_DESCRIPTION = "Call us on 1800 227 724 or email us at hello.au@cars24.com for all your car buying, selling, and financing enquiries. We are available Monday to Sunday - 8am to 8pm AEST.";

const ContactUs = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 Australia | Contact Us</title>
                <meta name="title" content={CONTACT_US_TITLE} />
                <meta property="og:title" content={CONTACT_US_TITLE} />
                <meta name="description" content={CONTACT_US_DESCRIPTION} />
                <meta property="og:description" content={CONTACT_US_DESCRIPTION} />
            </Helmet>
            <ErrorHandler>
                <div className="container mt-3">
                    <div styleName={"styles.mobileViewWrapper"}>
                        <ContactUsInfo trackEvents={trackDesktopCustomEventsAU}/>
                    </div>
                </div>
            </ErrorHandler>
        </React.Fragment>
    );
};

export default withAULayout(ContactUs, true, true, {headerProps: {showCallIcon: true, showWhiteMenu: false, showBlueMenu: true, showBlueWishlist: true}});
